/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Dirs_DescriptionInputs */

const es_settings_dirs_description = /** @type {(inputs: Settings_Dirs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carpetas sincronizadas desde tus proveedores de almacenamiento externo.`)
};

const en_settings_dirs_description = /** @type {(inputs: Settings_Dirs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folders synced from your external storage providers.`)
};

/**
* | output |
* | --- |
* | "Folders synced from your external storage providers." |
*
* @param {Settings_Dirs_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_description = /** @type {((inputs?: Settings_Dirs_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_description(inputs)
	return en_settings_dirs_description(inputs)
});
export { settings_dirs_description as "settings.dirs.description" }